export const getCompanyRcidFromTreeSelectionId = (
  selectionId: string
): number | null => {
  const companyDotMatch = selectionId.match(/^company\.(\d+)$/);
  if (companyDotMatch) {
    const rcid = Number(companyDotMatch[1]);
    return Number.isNaN(rcid) ? null : rcid;
  }

  const lastSegment = selectionId.split('_').pop();
  if (!lastSegment) {
    return null;
  }

  const rcid = Number(lastSegment);
  return Number.isNaN(rcid) ? null : rcid;
};
